import axios from '../../config/axios';
import { guardarTokenNativo } from '../../native/authNativo';

const state = {
  token: localStorage.getItem('token') || null,
  user: (() => {
    try {
      const u = localStorage.getItem('user');
      return u ? JSON.parse(u) : null;
    } catch {
      return null;
    }
  })()
};

const mutations = {
  setToken(state, token) {
    state.token = token;
    if (token) {
      localStorage.setItem('token', token);
      axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    } else {
      localStorage.removeItem('token');
      delete axios.defaults.headers.common['Authorization'];
    }
    guardarTokenNativo(token || '');
  },
  setUser(state, user) {
    state.user = user;
    if (user) {
      localStorage.setItem('user', JSON.stringify(user));
    } else {
      localStorage.removeItem('user');
    }
  },
  logout(state) {
    state.token = null;
    state.user = null;
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    ['miDia:ticktick:v1', 'miDia:datos:v1', 'miDia:agenda:v1'].forEach((k) => localStorage.removeItem(k));
    delete axios.defaults.headers.common['Authorization'];
    guardarTokenNativo('');
  }
};

const actions = {
  async setAuth({ commit, dispatch }, data) {
    commit('setToken', data.token);
    commit('setUser', data.user);
    axios.defaults.headers.common['Authorization'] = `Bearer ${data.token}`;
    // Limpiar datos del usuario anterior antes de cargar los del nuevo
    commit('clearData', null, { root: true });
    commit('suscripciones/clearSuscripciones', null, { root: true });
    try {
      await dispatch('initializeData', null, { root: true });
    } catch (e) {
      console.error('Error al inicializar datos tras registro:', e);
    }
  },

  async login({ commit, dispatch }, credentials) {
    try {
      console.log('Iniciando login con credenciales:', { 
        email: credentials.email,
        password: '********'
      });

      // Limpiar token y datos del usuario anterior
      commit('logout');
      commit('clearData', null, { root: true });
      commit('suscripciones/clearSuscripciones', null, { root: true });

      const response = await axios.post('/api/auth/login', credentials);
      console.log('Respuesta del servidor:', {
        status: response.status,
        statusText: response.statusText,
        data: { ...response.data, token: '[OCULTO]' }
      });
      
      if (!response.data || !response.data.token) {
        throw new Error('Respuesta inválida del servidor: no se recibió token');
      }
      
      commit('setToken', response.data.token);
      commit('setUser', response.data.user);
      
      // Configurar axios para futuras peticiones
      axios.defaults.headers.common['Authorization'] = `Bearer ${response.data.token}`;
      
      try {
        // Inicializar datos de la aplicación
        console.log('Inicializando datos después del login...');
        await dispatch('initializeData', null, { root: true });
        console.log('Datos inicializados correctamente');
      } catch (error) {
        console.error('Error al inicializar datos:', error);
        // No lanzar el error aquí, permitir que el login continúe
      }
      
      return response.data;
    } catch (error) {
      console.error('Error en proceso de login:', error);
      // Limpiar estado en caso de error
      commit('logout');
      
      if (error.response) {
        // El servidor respondió con un error
        throw error;
      } else if (error.request) {
        // No se recibió respuesta del servidor
        throw new Error('No se pudo conectar con el servidor');
      } else {
        // Error en la configuración de la petición
        throw new Error('Error al procesar la solicitud: ' + error.message);
      }
    }
  }
};

const getters = {
  isAuthenticated: state => !!state.token,
  currentUser: state => state.user,
  token: state => state.token,
  isAdmin: state => !!(state.user && state.user.es_admin),
  hasIngresos: state => !!(state.user && state.user.ingresos_habilitado),
  vistaInicio: state => (state.user?.vista_inicio || '/')
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}; 